import { TemplateComponent } from './template/template.component';
import { SenderDomainComponent } from './sender-domain/sender-domain.component';
import { EmailComponent } from './email/email.component';

export { TemplateComponent } from './template/template.component';
export { SenderDomainComponent } from './sender-domain/sender-domain.component';
export { EmailComponent } from './email/email.component';

export const containers = [
  TemplateComponent,
  SenderDomainComponent,
  EmailComponent,
];
